var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "        <div class=\"fr-bottom-button-row clearfix\">\n\n            <div class=\"fr-bbr-left pull-left\">\n                <input class=\"fr-search-submit btn btn-small btn-blue "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showSearchButtonAsButtonInfo : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "~\" type=\"submit\" value=\""
    + container.escapeExpression(((helper = (helper = helpers.submitButtonTitle || (depth0 != null ? depth0.submitButtonTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"submitButtonTitle","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableSearch : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n            </div>\n\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "btn-info";
},"4":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<form class=\"fr-search-form "
    + container.escapeExpression(((helper = (helper = helpers.extraFormClassName || (depth0 != null ? depth0.extraFormClassName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"extraFormClassName","hash":{},"data":data}) : helper)))
    + "\">\n\n    <div class=\"fr-search-model-region\" data-region=\"true\"></div>\n\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.dontShowFormButtons : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</form>\n\n\n\n\n\n\n\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/searchView/template.hbs
 ** module id = 611
 ** module chunks = 0
 **/